import { Metrics, Helpers, Heading1, Box } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { Savings as SolarSavings } from '../../CalculatorResult.types';
import { formatAsCurrency } from '../../../../../../utils/number/numberHelper';

const SavingsStyles = styled.div`
  background-color: rgb(237, 245, 236);
  border: 1px solid rgb(218, 237, 217);
  margin-top: ${Metrics.Spacing.M_Y_LG}px;
  text-align: center;
  padding: ${Metrics.Spacing.M_Y_SM}px 0;

  * {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    color: #004703;
    font-size: ${Metrics.FontSizes.BODY}px;
    text-align: left;
  }

  ${Helpers.media.MD`
    padding: ${Metrics.Spacing.M_Y_XL}px 0;
  `};
`;

export interface SavingsProps {
  savings: SolarSavings;
}

export const Savings: React.SFC<SavingsProps> = ({ savings }) => (
  <SavingsStyles>
    <Box marginRight={4}>
      <Heading1
        data-id="savingsRounded"
        text={`${formatAsCurrency(Math.floor(savings.billSavingsForPeriod!), {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}`}
        color="green"
      />
    </Box>
    <span>
      Estimated savings on <br /> your average quarterly bill
    </span>
  </SavingsStyles>
);
